const options = {
  5: "bg-neutral-100/5",
  10: "bg-neutral-100/10",
  25: "bg-neutral-100/25",
  50: "bg-neutral-100/50",
  75: "bg-neutral-100/75",
  90: "bg-neutral-100/90",
  100: "bg-neutral-100",
};

const from = {
  5: "from-neutral-100/5",
  10: "from-neutral-100/10",
  25: "from-neutral-100/25",
  50: "from-neutral-100/50",
  75: "from-neutral-100/75",
  90: "from-neutral-100/90",
  100: "from-neutral-100",
};

export default function getBackgroundNeutral100(opacity, isFrom) {
  return (isFrom ? from : options)[opacity || 100];
}
